export const getIndividualLoanAction = (state = {}, action) => {
  switch (action.type) {
    case "GET_INDIVIDUAL_LOAN_DETAILS":
      return action.data;

    default:
      return state;
  }
};
